<template>

    <div>
        <div id="query-tag-group"
            class="is-primary"
        >

            <b-tag v-if="query_user"
                class="query-tag"
                type="is-primary"
                attached
                closable
                size="is-large"
                aria-close-label="Close tag"
                @close="UpdateQuery('user', null)"
            >
                <span>{{ query_user }}</span>
            </b-tag>

            <b-tag v-if="query_tags"
                class="query-tag"
                type="is-primary"
                attached
                closable
                size="is-large"
                aria-close-label="Close tag"
                @close="UpdateQuery('tags__name', null)"
            >
                <span>{{ query_tags }}</span>
            </b-tag>

        </div>

    </div>

</template>


<script>

   import { ReviewableQuerys } from '../mixins/querys'

    export default {
        mixins: [ReviewableQuerys],
        data() {
            return {
            }
        },
        props: {
        },
        computed: {
        },
        methods: {
        },
        mounted() {
        }
    }

</script>


<style scoped lang="scss">
    @import "../styles/_variables.scss";

    #query-tag-group {
        position: fixed;
        left: 1em;
        bottom: 1em;
        z-index: 10;
    }
    .query-tag {
        margin: 0.2em;
    }

</style>
